export default __webpack_public_path__ + "static/media/1Automatiza.1ca1e041.svg";